import merge from 'lodash.merge';
import { combineLatest } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BadRequestHttpError } from '~shared/modules/error-handler';
import { IAdvancedFormConfig, IAdvancedFormEvent } from '~shared/modules/advanced-form/models/advanced-form.model';
import { IAddress } from '~shared/modules/addresses/models/address.model';
import { EDIT_ADDRESS_ACTION_LIST } from '../../constants/edit-address.constant';
import { AddressBookService } from '../../services/address-book.service';
import { BaseComponentClassDirective } from '~shared/classes/base-component.class';

@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.component.html',
})
export class EditAddressComponent extends BaseComponentClassDirective implements OnInit {
  public templateOptions = {};
  public advancedFormConfig: IAdvancedFormConfig;

  private address: IAddress;

  constructor(
    private activatedRoute: ActivatedRoute,
    private addressBookService: AddressBookService,
  ) {
    super();
  }

  public ngOnInit(): void {
    const advancedFormConfig$ = this.addressBookService.getAdvancedFormConfig();
    const address$ = this.addressBookService.getAddress(this.activatedRoute.snapshot.queryParams.id).pipe(first());

    combineLatest([advancedFormConfig$, address$])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([advancedFormConfig, address]) => {
      this.address = address;
      this.advancedFormConfig = merge({}, advancedFormConfig, {
        actionList: EDIT_ADDRESS_ACTION_LIST,
        initialFormData: address,
        fieldsExtraOptions: {
          defaultShipping: { isDisabled: address.defaultShipping },
          defaultBilling: { isDisabled: address.defaultBilling },
        },
      });
    });
  }

  public onAdvancedFormEvents(event: IAdvancedFormEvent): void {
    switch (event.type) {
      case 'submit':
        this.handleSubmit(event);
        break;

      case 'remove':
        this.handleRemove(event);
        break;
    }
  }

  private handleSubmit(event: IAdvancedFormEvent): void {
    const address = { ...this.address, ...event.payload.formData };
    this.addressBookService.updateAddress(address, event.payload.isDirty).subscribe(
      () => event.done(),
      (error: BadRequestHttpError) => event.done(error.invalidParams),
    );
  }

  private handleRemove(event: IAdvancedFormEvent): void {
    event.done();
    this.addressBookService.showDeleteAddressPopup(this.address.id);
  }
}
